import {React, useState, useEffect} from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Table from 'react-bootstrap/Table';
import { Button,Modal,ModalHeader,Label,Input } from 'reactstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import jsPDF from 'jspdf';
import 'jspdf-autotable';



export default function Reportclaims() {
    document.title = "Report-Claims | Definite Assurance Company Limited";

    const [claims, setClaims] = useState([]);
    const [status, setStatus] = useState("");
    const[start,setStart] = useState('');
    const[end,setEnd] = useState('');

        useEffect(()=>{
            const fetchClaims =async()=>{
                const res = await fetch('https://definitetempapi.uuidesign.xyz/api/getClaims');
                const data = await res.json();
                setClaims(data)
    
            }
    
            
    
            
            fetchClaims();    
        },[])


const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setStart(millisecondsSinceEpoch);
    
      };
      const handleDateChange2 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setEnd(millisecondsSinceEpoch);
       
      };


      const exportToPdf = () => {
        const doc = new jsPDF();
    
        // Add a title to the PDF
        doc.text("Newjo_Report_Claims", 20, 10);
    
        // Extract table headers and rows from the DOM
        const table = document.getElementById("dataTable");
        const headers = Array.from(
          table.querySelectorAll("thead tr th")
        ).map((header) => header.textContent);
    
        const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
          Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
        );
    
        // Generate the PDF table
        doc.autoTable({
          head: [headers],
          body: rows,
          startY: 20,
        });
    
        // Save the PDF
        doc.save("Newjo_Claims_report.pdf");
      };

  return (
    <div className='pagesContainer'>
          <Breadcrumbs title="Newjo" breadcrumbItem='Policies Report' />
          <div className="card">

          <div className="filterBar">
            <div className="flt">
            <div className="mb-4" id='mb'>
                <Label className="form-label">From date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange}
                    // value={email}

                />
                
            </div>
            <div className="mb-4" id='mb'>
                <Label className="form-label">To date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange2}
                    // value={email}

                />
                
            </div>
            <div className="mb-4" id='mb'>
                <Label className="form-label">Status</Label>
                <select name="" id="" className="form-control" onChange={(e)=>{setStatus(e.target.value)}}>
                    <option selected disabled>Status</option>
                    <option value=''>All</option>
                    <option value="Under Review">Under Review</option>
                    <option value="Rejected">Rejected</option>
                    <option value="Closed">Closed</option>
                   
                
                </select>
                
            </div>

            </div>

          
           
           
        </div>

        <div className='addButton'>
            <Button color='success' onClick={exportToPdf}>Export to PDF</Button>
        </div>



          <div className="table-responsive">
                <Table striped bordered hover id="dataTable">

                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Date</th>
                            <th scope="col">Policy Number</th>
                            <th scope="col">Client</th>
                            <th scope="col">Sum insured</th>
                            <th scope="col">Product</th>
                            <th scope="col">Premium</th>
                            <th scope="col">Premium received</th>
                            <th scope="col">status</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {claims.map((val,index)=>{
                            const date = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.createdAt)
              

                        if(start == '' && end == ''  && status == ''){
                            return(
                                <tr>
                                    <td>{index+1}</td> 
                                    <td>{date}</td>         
                                    <td>{val.policyNumber}</td>
                                    <td>{val.client}</td>
                                    <td>{val.sumInsured}</td>
                                    <td>{val.product}</td>
                                    <td>{val.grossPremium}</td>
                                    <td>{val.received}</td>
                                    <td>{val.status}</td>

                                </tr>
                            )

                        }

                        if(start < val.createdAt && end > val.createdAt  && status == ''){
                            return(
                                <tr>
                                    <td>{index+1}</td> 
                                    <td>{date}</td>         
                                    <td>{val.policyNumber}</td>
                                    <td>{val.client}</td>
                                    <td>{val.sumInsured}</td>
                                    <td>{val.product}</td>
                                    <td>{val.grossPremium}</td>
                                    <td>{val.received}</td>
                                    <td>{val.status}</td>

                                </tr>
                            )

                        }
                        if(start < val.createdAt && end > val.createdAt && status == val.status){
                            return(
                                <tr>
                                    <td>{index+1}</td> 
                                    <td>{date}</td>         
                                    <td>{val.policyNumber}</td>
                                    <td>{val.client}</td>
                                    <td>{val.sumInsured}</td>
                                    <td>{val.product}</td>
                                    <td>{val.grossPremium}</td>
                                    <td>{val.received}</td>
                                    <td>{val.status}</td>

                                </tr>
                            )
                        }
                       
                       
                            
                        })}
                    </tbody>
                </Table>
            </div>

          </div>
    </div>
  )
}
